import { r as react } from './index-3eed8459.js';

var LocaleContext = /*#__PURE__*/react.createContext(undefined);

export { LocaleContext as L };
